module.exports = __webpack_public_path__ + "img/Frame 1060one.a19bf3ba.png";